import { useTranslation } from 'react-i18next';

const languageCodes: Record<string, string> = {
  no: 'nb',
  se: 'sv',
};

export const useSanityLanguageCode = () => {
  const {
    i18n: { language },
  } = useTranslation();

  return languageCodes[language];
};
